module.exports = {
    controller: customsOfficeFormController,
    templateUrl: 'customs-offices/components/customs-office-form.html'
}

customsOfficeFormController.$inject = [
    '$location',
    '$q',
    '$routeParams',
    '$translate',
    'customsOfficeDataService', 
];

function customsOfficeFormController(
    $location,
    $q,
    $routeParams,
    $translate,
    customsOfficeDataService
) {
    var vm = {
        $onInit: attached,
        service: customsOfficeDataService,
        filter: customsOfficeDataService.filter,
        roleGroups: [],
        cutomsOffices: [],
        onClickSearch: onClickSearch,
        changeRoleGroup: changeRoleGroup,
        onSelectCountry: onSelectCountry,
        onSelectRegion: onSelectRegion,
        onSelectCity: onSelectCity,
        days : [{ isSelected: false, day: 1, name :'Monday'},
                { isSelected: false, day: 2, name :'Tuesday'},
                { isSelected: false, day: 3, name :'Wednesday'},
                { isSelected: false, day: 4, name :'Thursday'},
                { isSelected: false, day: 5, name :'Friday'},
                { isSelected: false, day: 6, name :'Saturday'},
                { isSelected: false, day: 7, name :'Sunday'},],
        isOpenNow: false,
        searchCustomsOffices: searchCustomsOffices
    }

    return vm;

    function attached() {
        vm.service.activeCustomsOffice = null;
        vm.service.response.Results = null; 
        $q.all([
            loadTranslations(),
            customsOfficeDataService.loadRoleGroups(),
            customsOfficeDataService.loadCountries(),
            customsOfficeDataService.loadTrafficTypes()
        ]).then(() => {
            if (!$routeParams.referenceNumber) {
                customsOfficeDataService.loadCustomsOffices();
            }
        });
    }

    function loadTranslations() {
        return $translate([
            'shared.ui.Weekdays.Monday',
            'shared.ui.Weekdays.Tuesday',
            'shared.ui.Weekdays.Wednesday',
            'shared.ui.Weekdays.Thursday',
            'shared.ui.Weekdays.Friday',
            'shared.ui.Weekdays.Saturday',
            'shared.ui.Weekdays.Sunday'
        ]).then(function (translations) {
            vm.translations = translations;
            vm.days = [
                { isSelected: false, day: 1, name: translations['shared.ui.Weekdays.Monday'] },
                { isSelected: false, day: 2, name: translations['shared.ui.Weekdays.Tuesday'] },
                { isSelected: false, day: 3, name: translations['shared.ui.Weekdays.Wednesday'] },
                { isSelected: false, day: 4, name: translations['shared.ui.Weekdays.Thursday'] },
                { isSelected: false, day: 5, name: translations['shared.ui.Weekdays.Friday'] },
                { isSelected: false, day: 6, name: translations['shared.ui.Weekdays.Saturday'] },
                { isSelected: false, day: 7, name: translations['shared.ui.Weekdays.Sunday'] }
            ]
        });
    }

    function onClickSearch() {
        // search from details page - we want to prevent calling the API twice - it is also called on page load
        if ($location.url() !== '/customs-offices') {
            $location.url('/customs-offices');
        }
        else {
            searchCustomsOffices();
        }
    }

    function searchCustomsOffices() {

        customsOfficeDataService.filter.isOpenByDay = vm.days
            .filter(f => f.isSelected)
            .map(item => item.day)
            .join(",");
        
        customsOfficeDataService.loadCustomsOffices();
    }

    function changeRoleGroup() {
        customsOfficeDataService.changeRoleGroup();
    }

    function onSelectCountry(country) {
        if (country) {
            customsOfficeDataService.filter.country = country.code;
            customsOfficeDataService.loadRegions();
            customsOfficeDataService.loadCities();
        }
        else {
            customsOfficeDataService.Cities = [];
            customsOfficeDataService.Regions = [];
            customsOfficeDataService.filter.country = null;
            customsOfficeDataService.filter.region = null;
            customsOfficeDataService.filter.city = null;
            customsOfficeDataService.filter.isOpenByDay = null;
            customsOfficeDataService.filter.isOpenNow = false;
        }
    }

    function onSelectRegion(region) {
        if (region) {
            customsOfficeDataService.filter.region = region.code;
        }
        else 
        {
            customsOfficeDataService.filter.region = null;
        }
        customsOfficeDataService.Cities = [];
        customsOfficeDataService.filter.city = null;
        customsOfficeDataService.loadCities();
    }

    function onSelectCity(city) {
        if(city) 
        {
            customsOfficeDataService.filter.city = city.CityName;
        }
        else 
        {
            customsOfficeDataService.filter.city = null;
        }
    }
}